/**
 * Helper functions for creating modern JAQL syntax compliant with Sisense standards
 */

/**
 * Creates a modern JAQL filter structure with explicit and multiSelection properties
 * @param {Array|*} values - The filter values (can be array or single value)
 * @param {boolean} isExplicit - Whether the filter is explicit (default: true)
 * @returns {Object} Modern JAQL filter object
 */
export function createModernFilter(values, isExplicit = true) {
  return {
    explicit: isExplicit,
    multiSelection: Array.isArray(values) && values.length > 1,
    members: Array.isArray(values) ? values : [values]
  };
}

/**
 * Creates a dimension reference in bracketed format
 * @param {string} table - The table name
 * @param {string} column - The column name
 * @returns {string} Bracketed dimension reference
 */
export function createDimensionReference(table, column) {
  return `[${table}.${column}]`;
}

/**
 * Creates a datasource object in modern JAQL format
 * @param {string} title - The datasource title
 * @returns {Object} Datasource object
 */
export function createDatasourceObject(title) {
  return { title };
}

/**
 * Creates a complete metadata item for JAQL
 * @param {string} dimension - The dimension reference (should be bracketed)
 * @param {string} datatype - The data type (text, numeric, datetime)
 * @param {Object} filter - Optional filter object
 * @param {string} title - Optional display title
 * @returns {Object} JAQL metadata item
 */
export function createMetadataItem(dimension, datatype, filter = null, title = null) {
  const item = {
    jaql: {
      dim: dimension,
      datatype: datatype
    }
  };

  if (filter) {
    item.jaql.filter = filter;
  }

  if (title) {
    item.jaql.title = title;
  }

  return item;
}